import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

const sections = document.querySelectorAll( '.e-stn--focus-scroll, .e-stn--focus-scroll-with-cta' );
const isMobile = window.innerWidth < 768;

const setupScrollAnimation = ( stickyContents, medias, section ) => {
  if( window.innerWidth < 768 ) { return;}
  stickyContents.forEach( ( stickyContent, index ) => {
    ScrollTrigger.getAll().forEach( trigger => {
      if ( trigger.trigger === stickyContent ) {
        trigger.kill();
      }
    } );
    const cardHeight = stickyContent.offsetHeight;
    const items = section.querySelectorAll( '.e-acc__itm-wrpr' );

    gsap.to( stickyContent, {
      duration: 1,
      scrollTrigger: {
        trigger: stickyContent,
        start: `top ${updateStartPosition( section )}`,
        end: `+=${cardHeight}`,
        scrub: 0.8,
        invalidateOnResize: true,
        onEnterBack: () => updateClasses( medias, index, items, section ),
        onEnter: () => updateClasses( medias, index, items, section ),
      }
    } );
  } );
};

const updateClasses = ( medias, index, items, section ) => {
  medias.forEach( media => media.classList.remove( 'active-media' ) );
  items.forEach( item => item.classList.remove( 'active-item' ) );
  if ( !isMobile ) {
    pauseVideos( section );
  }
  medias[index]?.classList.add( 'active-media' );
  items[index]?.classList.add( 'active-item' );
  const hasVideo = medias[index]?.querySelector( 'video' );
  hasVideo?.play();
};

const pauseVideos = ( section ) => {
  section.querySelectorAll( 'video' ).forEach( 
    vid => {
      if ( !vid.paused ) {
        vid.pause();
        setTimeout( () => {
          vid.currentTime = 0;
        }, 600 );
      }
    }
  );
};

function handleSectionClick( section ) {
  const accordionTabs = section.querySelectorAll( '.e-acc__itm-wrpr' );

  accordionTabs.forEach( slide => {
    // Pause and reset all videos initially
    slide.querySelectorAll( 'video' ).forEach( 
      vid => { 
        vid.pause();
        vid.currentTime = 0;
      } );

    // If this slide is active, play its first video
    if ( slide.classList.contains( 'active' ) ) {
      const video = slide.querySelector( 'video' );
      if ( video ) {
        video.play();
      }
    }

    // Add click listener to each slide
    const itemHeader = slide.querySelector( '.e-acc__itm-hdr-wrpr' );
    itemHeader.addEventListener( 'click', () => {
      // Pause and reset all videos in the section
      section.querySelectorAll( 'video' ).forEach( 
        vid => { 
          vid.pause(); 
          vid.currentTime = 0;
        }
      );
      const currentVideo = slide.querySelector( 'video' );
      setTimeout( () => {
        if( currentVideo && slide.classList.contains( 'active' ) ) {
          currentVideo.currentTime = 0;
          currentVideo.play();
        }
      }, 50 );
    } );
  } );
}

const updateStickyPosition = ( section ) => {
  const hH = document.querySelector( 'header' ).offsetHeight;
  const mediaWrapper = section.querySelector( '.e-acc__media-wrpr' );
  const mediaWrapperMarginTop = window.getComputedStyle( mediaWrapper ).marginTop;
  const topPosition = hH + parseFloat( mediaWrapperMarginTop );

  mediaWrapper.style.top = `${topPosition}px`;
  
  return topPosition;
};

const updateStartPosition = ( section ) => {
  const stickyPosition = updateStickyPosition( section );
  const mediaWrapper = section.querySelector( '.e-acc__media-wrpr' );
  const mediaWrapperMinHeight = window.getComputedStyle( mediaWrapper ).minHeight;
  const startPosition = stickyPosition + ( parseFloat( mediaWrapperMinHeight ) / 2 );
  
  return startPosition;
};
document.addEventListener( 'DOMContentLoaded', () => {
  if ( sections.length == 0 ) return;
  sections.forEach( section => {
    const accordion =
    section.querySelector( '.e-acc--focus-scroll' ) ||
    section.querySelector( '.e-acc--focus-scroll-with-cta' );

    if ( !accordion ) return;

    const stickyContents = gsap.utils.toArray( '.e-acc__itm-wrpr', accordion );
    const accordionItems = accordion.querySelectorAll( '.e-acc__itm-wrpr' );
    const accordionMediaWrapper = document.createElement( 'div' );
    accordionMediaWrapper.classList.add( 'e-acc__media-wrpr' );
    accordionItems.forEach( ( item, index ) => {
      item.classList.add( `item-${ index + 1 }` );
      const mediaElement = item.querySelector( '.e-div--media-wrapper' );
      const clonedMedia = mediaElement.cloneNode( true );
      clonedMedia.classList.add( `media-${ index + 1 }` );
      accordionMediaWrapper.appendChild( clonedMedia );
      if( index === 0 ) {
        item.classList.add( 'active-item' );
        clonedMedia.classList.add( 'active-media' );
      }
    } );
    accordion?.appendChild( accordionMediaWrapper );
    const resizeObserver = new ResizeObserver( () => {
      updateStickyPosition( section );
      setupScrollAnimation( 
        stickyContents, 
        accordionMediaWrapper.querySelectorAll( '.e-div--media-wrapper' ), 
        section );
    } );
    handleSectionClick( section );
    resizeObserver.observe( section );
  } );
} );

const observer = new IntersectionObserver( ( entries ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      entry.target.classList.add( 'in-viewport' );
    } else {
      entry.target.classList.remove( 'in-viewport' );
    }
  } );
}, {
  threshold: 0.15
} );

sections.forEach( section => {
  observer.observe( section );
} );